import type { BlogArticle } from '../../types/blog'
import { implantsCostArticle } from './implantsCostArticle'
import { nhsVsPrivateArticle } from './nhsVsPrivateArticle'
import { withoutInsuranceArticle } from './withoutInsuranceArticle'
import { toothacheArticle } from './toothacheArticle'
import { veneersGuideArticle } from './veneersGuideArticle'
import { chooseDentistArticle } from './chooseDentistArticle'

/** Order matches the blog listing page. */
export const blogArticles: BlogArticle[] = [
  implantsCostArticle,
  nhsVsPrivateArticle,
  withoutInsuranceArticle,
  toothacheArticle,
  veneersGuideArticle,
  chooseDentistArticle,
]
